import { render, staticRenderFns } from "./purinvoicecost.vue?vue&type=template&id=df39a394&scoped=true&"
import script from "./purinvoicecost.vue?vue&type=script&lang=js&"
export * from "./purinvoicecost.vue?vue&type=script&lang=js&"
import style0 from "./purinvoicecost.vue?vue&type=style&index=0&id=df39a394&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df39a394",
  null
  
)

export default component.exports